import axios from "axios";
import { API_PROD_URL } from "src/utils/axios";

const WIREFRAME_ENDPOINT = "/newsletter-agent-v2/save-wireframe";
const CONTEXT_PREVIEW_ENDPOINT = "/newsletter-agent-v2/context-preview";
const GENERATE_CONTENT_ENDPOINT = "/newsletter-agent-v2/generate-content";
const EMAIL_TEMPLATE_ENDPOINT = "/newsletter-agent-v2/email-layout";
const EMAIL_TEMPLATE_LIST_ENDPOINT = "/newsletter-agent-v2/list-email-templates";
const EMAIL_TEMPLATE_GENERATE_ENDPOINT = "/newsletter-agent-v2/generate-from-template";

export type DataField = {
  field_name: string;
  field_type: string;
  data: string;
  description?: string;
};

export type SaveDataCollectedPayload = {
  selected_layout: string;
  data_fields: DataField[];
};


async function confirmEmailWireframe(user_id: string, thread_id: string, wireframedata: any) {
  try {
    const response = await fetch(API_PROD_URL+WIREFRAME_ENDPOINT+`?userId=${user_id}&threadId=${thread_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ wireframedata }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

   
    return await response.json();
  } catch (error) {
    console.error("Error confirming email wireframe:", error);
    throw error;
  }
}

async function confirmContextPreview(user_id: string, thread_id: string, context: any) {
    try {
        const response = await fetch(API_PROD_URL+CONTEXT_PREVIEW_ENDPOINT+`?userId=${user_id}&threadId=${thread_id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ context }),
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

      
        return await response.json();
    } catch (error) {
        console.error("Error saving context preview:", error);
        throw error;
    }
}

async function generateText(user_id: string, thread_id: string, instruction: string,context:any) {
    try {
        const response = await fetch(API_PROD_URL+GENERATE_CONTENT_ENDPOINT+`?userId=${user_id}&threadId=${thread_id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ instruction, context }),
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

       
        return await response.json();
    } catch (error) {
        console.error("Error generating text:", error);
        throw error;
    }
}

async function confirmEmailTemplate(user_id: string, thread_id: string, email_layout: any) {
    try {
        const response = await fetch(API_PROD_URL+EMAIL_TEMPLATE_ENDPOINT+`?userId=${user_id}&threadId=${thread_id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email_layout }),
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }


        return await response.json();
    } catch (error) {
        console.error("Error confirming email template:", error);
        throw error;
    }
}

async function fetchEmailTemplateList(user_id: string) {
    try {
        const response = await fetch(API_PROD_URL+EMAIL_TEMPLATE_LIST_ENDPOINT+`?userId=${user_id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

    
        return await response.json();
    } catch (error) {
        console.error("Error fetching email template list:", error);
        throw error;
    }
}

async function generateEmailForSelectedTemplate(user_id: string, thread_id: string,template_id:any){
    try {
        const response = await fetch(API_PROD_URL+EMAIL_TEMPLATE_GENERATE_ENDPOINT+`?userId=${user_id}&threadId=${thread_id}&template_id=${template_id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

     
        const data = await response.json();
       
        return data;
    } catch (error) {
        console.error("Error generating email from selected template:", error);
        throw error;
    }
}

const saveDataCollected = async (
  userId: string,
  threadId: string,
  payload: SaveDataCollectedPayload
) => {
  const response = await axios.post(
    `${API_PROD_URL}/newsletter-agent-v2/save-data-collected`,
    payload,
    {
      params: {
        userId,
        threadId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

type SaveEmailPayload = {
  raw_html: string;
};

const saveEmailLayout = async (
  userId: string,
  threadId: string,
  payload: SaveEmailPayload
) => {
  const response = await axios.post(
    `${API_PROD_URL}/newsletter-agent-v2/email-layout`,
    payload,
    {
      params: {
        userId,
        threadId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

const saveWhitepaperReportLayout = async (
  userId: string,
  threadId: string,
  htmlString: string
) => {
  const response = await axios.post(
    `${API_PROD_URL}/whitepaper-agent-v1/save_html_string`,
    htmlString,
    {
      params: {
        user_id: userId,
        thread_id: threadId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

const downloadHtml = async (
  userId: string,
  threadId: string
) => {
  const response = await axios.get(
    `${API_PROD_URL}/whitepaper-agent-v1/download_html`,
    {
      params: {
        user_id: userId,
        thread_id: threadId,
      },
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response.data;
};



export { confirmEmailWireframe, confirmContextPreview,saveEmailLayout,downloadHtml,saveWhitepaperReportLayout, generateText, confirmEmailTemplate, fetchEmailTemplateList, generateEmailForSelectedTemplate,saveDataCollected };